import Vue from "vue";
import Router from "vue-router";
import home from "../pages/Home";
import Trend from "../pages/Trend";
import GameList from "../pages/GameList";

Vue.use(Router);

export default new Router({
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
  mode: "history",
  // mode: 'hash',

  routes: [
    {
      path: "/",
      name: "Home",
      component: home
    },
    {
      path: "/GameList",
      name: "GameList",
      component: GameList
    },
    {
      path: "/Trend/:betType/:gameType",
      name: "Trend",
      component: Trend
    },
    {
      path: "/mobile",
      name: "mobile",
      component: () => import("@/pages/Mobile/Game/index.vue")
    },
    {
      path: "/mobiletrend/:betType/:gameType",
      name: "mobiletrend",
      component: () => import("@/pages/Mobile/MobileTrend/index.vue")
    },
    {
      path: "/RulesOfPlay",
      name: "RulesOfPlay",
      component: () => import("@/pages/Mobile/RulesOfPlay/index.vue")
    },
    {
      path: "/Detail/:gameType/:Desc",
      name: "Detail",
      component: () => import("@/pages/Mobile/Detail/index.vue")
    },
    {
      path: "/Game",
      name: "Game",
      component: () => import("@/pages/Mobile/Game/index.vue")
    },
    {
      path: "/Chat",
      name: "Chat",
      component: () => import("@/pages/Mobile/Chat/index.vue")
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js